// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tip[data-v-e22f2ad2] {\n  font-size: 14px;\n  color: #666;\n}\n.listWrapper[data-v-e22f2ad2] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.listWrapper .item[data-v-e22f2ad2] {\n  margin-bottom: 5px;\n  margin-right: 20px;\n}\n.listWrapper .item .label[data-v-e22f2ad2] {\n  width: 100px;\n  text-align: right;\n  display: inline-block;\n}", ""]);
// Exports
module.exports = exports;
